import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import { fetchContactRequestReasonIfNeeded } from '../../../services/contactrequest/actions';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import ContactRequestFormComponent from './ContactRequestFormComponent';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

export class ContactRequestPage extends React.Component {
    componentDidMount() {
        this.props.fetchContactRequestReasonIfNeeded();
    }

    render() {
        const { i18n } = this.props;
        return (
            <main className="conteneur conteneur-mobile" id="p-contactrequest">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.CONTACTREQUEST_PATH}`}
                />
                <LocalizedBreadcrumbItem to={PATH.CONTACTREQUEST_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.PAGE_TITLE}</h1>
                <ContactRequestFormComponent />
            </main>
        );
    }
}

ContactRequestPage.propTypes = {
    i18n: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.CONTACTREQUEST
    };
};

const mapDispatchToProps = {
    fetchContactRequestReasonIfNeeded
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(ContactRequestPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/contactrequest/ContactRequestPage.js